export const tableHead = [
    {
        title: "Rider Name",
        width: "20%",
    },
    {
        title: "Contact No.",
        width: "12%",
    },
    {
        title: "Transaction Id",
        width: "18%",
    },
    {
        title: "Date",
        width: "13%",
    },
    {
        title: "Pay Mode",
        width: "10%",
    },
    {
        title: "Amount Paid",
        width: "10%",
    },
    {
        title: "Ride Status",
        width: "10%",
    },
    {
        title: "Action",
        width: "7%",
    },
];
